goog.provide("shadow.js.shim.module$$mui$material$ListSubheader$default");
shadow.js.shim.module$$mui$material$ListSubheader$default = shadow.js.require(495, {})["default"];
